module.exports = __webpack_public_path__ + "static/img/img1-en.b9aaa89.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/img1-en.png
// module id = w77c
// module chunks = 1